<div> 
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-sm-12">
               <div class="pt-5 mt-5 lft-sticky-section">
                    <div class="mb-3"><span class="categoryTag">{{podcastDetails.category}}</span></div>
                    <h1 class="heading-three">{{podcastDetails.title}}</h1>
                    <p class="paragraph-global-text mb-0">
                        {{podcastDetails.speakerDetails.name}} {{podcastDetails.speakerDetails.description}}
                    </p>
                    <hr class="my-3">
                    <p class="paragraph-global-text sub-heading-color"> Brief</p>
                    <p class="paragraph-global-text mb-0"> {{podcastDetails.brief}}</p>
                    <hr class="my-3">
                    <p class="paragraph-global-text sub-heading-color">
                    <span>Posted on {{podcastDetails.postDetails.postedDate}}</span> · <span>{{podcastDetails.postDetails.duration}}</span>
                    </p>
                    <div class="tags mt-3 mb-5" *ngIf="podcastDetails.tags && podcastDetails.tags?.length > 0">
                        <span *ngFor="let tag of podcastDetails.tags" class="related-tags">{{tag}}</span>
                    </div>

                    <div class="social-icons mt-4">
                        <ul class="no-flex-wrap">
                          <li>
                            <a href="{{sharedService.twitter}}" target="_blank">
                              <i class="fa-brands fa fa-x-twitter"></i>
                            </a>
                          </li>
                          <li>
                            <a href="{{sharedService.youtube}}" target="_blank">
                              <i class="fa-brands fa fa-youtube"></i>
                            </a>
                          </li>
                          <li>
                            <a href="{{sharedService.facebook}}" target="_blank">
                              <i class="fa-brands fa fa-facebook-f"></i>
                            </a>
                          </li>
                          <li>
                            <a href="{{sharedService.instagram}}" target="_blank">
                              <i class="fa-brands fa fa-instagram"></i>
                            </a>
                          </li>
                          <li>
                            <a href="{{sharedService.linkedin}}" target="_blank">
                              <i class="fa-brands fa fa-linkedin"></i></a>
                          </li>
                  
                          <li>
                            <a href="{{sharedService.medium}}" target="_blank"><i class="fa-brands fa fa-medium"></i></a>
                          </li>
                  
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-8 col-sm-12">
                <div class="pt-5 mt-5">
                    <div class="div-video-content-width">
                        <!-- <iframe width="100%" height="415" src="https://www.youtube.com/embed/yjTnkLXil-o?si=Rz06Sq0Bjl_qL9PG" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
                        <div id="featureVideoPlayer"></div>

                        <div class="mt-5">
                            <p class="paragraph-global-text">{{podcastDetails.speakerBio}}</p>
                            <h4 class="heading-three mt-4">Video clips</h4>

                            <div class="video-clip card-hover-effect" (click)="seekToTime(clip.timeStamp)" *ngFor="let clip of podcastDetails.videoClips">
                                <div>
                                    <p class="paragraph-global-text sub-heading-color mb-1"><i class="pi pi-clock f-14 sub-heading-color mr-2"></i> {{clip.duration}}</p>
                                    <h6 class="heading-four mb-0 desc-1">{{clip.title}}</h6>
                                </div>
                                <div>
                                    <a class="primary-color no-text-wrap">
                                        <img class="watch-img mx-3" width="30" src="../../../assets/icons/podcast/play-blue-icon.svg" alt="">
                                        <span class="fw-500">Watch now</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="sec-padding">    
    <div class="container z-index">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-two mx-auto mw-800">{{'podcasts.related' | translate}}</h2>
        </div>
  
        <!-- cards  -->
        <div class="row mx-0 m-col-width card-v-gap">
            <div class="col-lg-4 col-md-6 col-sm-12" *ngFor="let video of podcasts">
                <div class="card podcast-card justify-content-between card-hover-effect">
                   <div>
                        <div class="podcast-img w-100">
                            <img class="thumbnail-img" [src]="video.thumbnail" [alt]="video.title">
                        </div>
                        <div class="podcast-card-content-sec">
                            <img class="play-video-icon" src="../../../assets/icons/podcast/play-blue-icon.svg" alt="">
                            <p class="paragraph-global-text sub-heading-color">{{video.presenter}}</p>
                            <h4 class="heading-four desc-3 mb-3">{{video.title}}</h4>
                            <p class="paragraph-global-text sub-head-paragraph mb-0"> <i class="pi pi-clock mr-2"></i> {{video.duration}}</p>
                        </div>
                   </div>
                   <a [routerLink]="'/en/podcasts/' + video.id" class="video-btn">View video clips</a>
                </div>
             </div>
        </div>
    </div>
</div>

<div class="sec-padding cfa-sec position-relative">    
    <div class="cfa-grid"></div>
  <div class="container z-index">
      <div class="sec-title text-center">
          <h2 class="heading-one text-white mx-auto">{{'podcasts.cfa.title' | translate}} </h2>
          <p class="paragraph-global-text sub-head-paragraph mw-750 text-white">{{'podcasts.cfa.description' | translate}}</p>

          <div class="button-container mt-4">
              <a class="save-btn cfa btn" [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
                {{'podcasts.cfa.btnText' | translate}}
              </a>
          </div>
      </div>
  </div>
</div>